import SchemaTyped from 'rsuite/esm/Schema/Schema';

export const getValidatorConfigurationForAnswerType = (
  answerType,
  isRequired = false
) => {
  const { StringType, NumberType } = SchemaTyped.Types;
  let validatorConfig = {
    validator: null,
    defaultErrorMessage: '',
  };
  switch (answerType) {
    case 'positive_number':
      validatorConfig.validator = NumberType().min(0);
      validatorConfig.defaultErrorMessage = 'Must be a positive number';
      break;
    case 'boolean':
      validatorConfig.validator = StringType().addRule(
        (value) => value === 'Yes' || value === 'No',
        null
      );
      validatorConfig.defaultErrorMessage = 'Selection is required';
      break;
    case 'string':
    default:
      validatorConfig.validator = StringType();
      validatorConfig.defaultErrorMessage = 'Must be text.';
  }

  if (isRequired && validatorConfig.validator) {
    validatorConfig.validator = validatorConfig.validator.isRequired();
  }
  return validatorConfig;
};

export const getConditionsConfiguration = (question) => {
  const conditionDescriptions = question.conditions;
  const conditionConfigs = conditionDescriptions?.map((condition) => {
    return {
      compareKey: condition.key,
      evaluationFn: mapConditionDescriptionToCallback(condition),
    };
  });
  return conditionConfigs;
};

const mapConditionDescriptionToCallback = (description) => {
  switch (description.op) {
    case 'equal':
      return (val) => val === description.value;
    case 'notEqual':
      return (val) => val !== description.value;
    case 'jsonEq':
      return (val) => JSON.stringify(val) === JSON.stringify(description.value);
    case 'notjsonEq':
      return (val) => JSON.stringify(val) !== JSON.stringify(description.value);
    case 'isNumberUnset':
      return (val) => val === undefined || val === null;
    case 'isDefined':
      return (val) => val !== undefined && val !== null;
    case 'isTruthy':
      return (val) => val == description.value;
    case 'isFalsy':
      return (val) => val != description.value;
    case 'any':
      return (val) =>
        !Array.isArray(description.value) ||
        (Array.isArray(description.value) && description.value.includes(val));
    case 'noneOf':
      return (val) =>
        !Array.isArray(description.value) ||
        (Array.isArray(description.value) && !description.value.includes(val));
    case 'dateIsBefore':
      return (val) =>
        val instanceof Date &&
        description.value instanceof Date &&
        val.getTime() < description.value.getTime();
    case 'dateIsAfter':
      return (val) =>
        val instanceof Date &&
        description.value instanceof Date &&
        val.getTime() > description.value.getTime();
    case 'dateIsSame':
      return (val) =>
        val instanceof Date &&
        description.value instanceof Date &&
        val.getTime() === description.value.getTime();
    case 'greaterThan':
      return (val) => val > description.value;
    case 'greaterThanOrEqual':
      return (val) => val >= description.value;
    case 'lessThan':
      return (val) => val < description.value;
    case 'lessThanOrEqual':
      return (val) => val <= description.value;
    default:
      return () => null;
  }
};
